import React, { useCallback } from 'react';
import { Button, BUTTON_TYPES } from '../../Button/Button';
function TeaserButton({ buttonProps, teaserIndex }) {
    /** Variables */
    const onClickMemo = useCallback(() => {
        if (buttonProps.onClick) {
            buttonProps.onClick(teaserIndex);
        }
    }, [buttonProps.onClick, teaserIndex]);
    if (buttonProps.type !== BUTTON_TYPES.PRIMARY && (buttonProps.iconLeft || buttonProps.iconRight)) {
        buttonProps.isIconOnlyMobile = true;
    }
    /** JSX */
    return React.createElement(Button, { ...buttonProps, onClick: onClickMemo });
}
export default TeaserButton;
